import { ReactComponent as Table } from '@/assets/img/table.svg';
import { Style } from '@/components/style';
import { useIntl } from 'react-intl';

const { blackColor, gray3Color, gray1Color, gray2Color } =
  new Style().getUiConfig();

function PagerCode({ pagerCode }) {
  const intl = useIntl();
  return (
    pagerCode && (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'start', // 水平置中
          padding: '10px',
          width: '100%',
          height: '42px',
          fontSize: '16px',
          borderRadius: '10px', // 圓角
          border: `1px solid ${gray2Color}`, // 灰色邊框
          backgroundColor: gray1Color, // 背景色
        }}
      >
        {/* Icon */}
        <Table
          style={{
            marginRight: '8px', // Icon 與文字間距
          }}
        />

        {/* 文字 */}
        <input
          style={{
            border: 'none', // 移除內部邊框
            outline: 'none', // 移除選中時的外框
            backgroundColor: 'transparent', // 背景透明
            fontSize: '16px', // 字體大小
            color: gray3Color, // 黑色文字
          }}
          type="text"
          disabled
          placeholder={`${intl.formatMessage({
            id: 'pagerCode.title',
          })} ${pagerCode}`}
        />
      </div>
    )
  );
}

PagerCode.defaultProps = {};

PagerCode.propTypes = {};

export default PagerCode;
